import { render, staticRenderFns } from "./xy2.vue?vue&type=template&id=e02bee14&scoped=true&"
import script from "./xy2.vue?vue&type=script&lang=js&"
export * from "./xy2.vue?vue&type=script&lang=js&"
import style0 from "./xy2.vue?vue&type=style&index=0&id=e02bee14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02bee14",
  null
  
)

export default component.exports